export const OrgScopedPathPatterns: ReadonlyArray<string> = [
  '/announcements',
  '/analysis/:analysisId',
  '/dashboard',
  '/dashboard/customer',
  '/patients',
  '/patients/:patientId',
  '/providers',
  '/providers/:providerId',
  '/projects',
  '/projects/:projectId',
  '/members',
  '/members/invitations',
  '/requests',
  '/requests/:practiceRequestId',
  '/uncollectible',
  '/rules',
  '/claim-rules',
  '/scrubber',
  '/scrubber/timesheets/:timebillingId',
  '/dropbox',
  '/faxes',
]
